import * as e from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/BellSlash.es.js";
const o = e.forwardRef((a, l) => /* @__PURE__ */ e.createElement(r, { ref: l, ...a, weights: s }));
o.displayName = "BellSlashIcon";
const c = o;
export {
  c as BellSlash,
  o as BellSlashIcon
};
